import React from "react";
import { Row, Col, Tooltip, Icon } from "antd";

import styles from "./styles/IndexSection.scss";
import { StaticHTML } from "../../../components";
import { DetailGroupType } from "../../../models";
import {
  replaceLineBreaksByTag,
  resolveLastLineItem
} from "../../../services/utils";
import { getIconUrl } from "../../../services/asset";
import { processTextWithPhoneNumbers } from "../../../utils/phoneUtils";
import { CarverticalVinLink, VIN_DETAIL_TITLE } from "../../../components/CarverticalWidget";

interface GAEvent {
  category: string;
  action: string;
  label: string;
}

const renderItemData = (
  itemData: any,
  index: any,
  type: any,
  lastLineItem: any,
  gaEvent: GAEvent,
  adId?: string
) => {
  switch (type) {
    case DetailGroupType.valueOnly:
      return (
        <div key={index} className={styles.valueOnly}>
          <div className={styles.group}>
            {itemData.group}
            {itemData.tooltip && (
              <Tooltip title={itemData.tooltip} placement="top">
                <Icon
                  className={styles.infoIcon}
                  type="info-circle-o"
                />
              </Tooltip>
            )}
          </div>
          {itemData.data.map((data: any, i: any) => (
            <Col
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              md={12}
              className={`${styles.text}`}
            >
              <img alt={data} src={getIconUrl("section-check.svg")} />
              <StaticHTML content={data} />
            </Col>
          ))}
        </div>
      );

    case DetailGroupType.valueWithTitle: {
      const isVinRow =
        itemData.title === VIN_DETAIL_TITLE && itemData.value && itemData.value.length > 0;

      const titleSpan = (
        <span className={styles.title}>
          {itemData.title}
          {itemData.tooltip && (
            <Tooltip title={itemData.tooltip} placement="top">
              <Icon
                className={styles.infoIcon}
                type="info-circle-o"
              />
            </Tooltip>
          )}
        </span>
      );

      const valueSpan = <span className={styles.value}>{itemData.value}</span>;

      // VIN row uses a column-stack layout: title/value stay on one row
      // (nested `.valueRow`), Carvertical link on its own row below.
      // This bypasses the flex-wrap fragility in `.valueWrapper` after the
      // dev2 merge (where the wrapper becomes `display: flex` and would
      // otherwise squish title/value char-by-char to make room for the link).
      return (
        <Col md={12} key={index} className={styles.valueWithTitle}>
          <div
            className={`${styles.valueWrapper} ${isVinRow ? styles.valueWrapperVin : ''} ${lastLineItem &&
              styles.lastLine}`}
          >
            {isVinRow ? (
              <React.Fragment>
                <div className={styles.valueRow}>
                  {titleSpan}
                  {valueSpan}
                </div>
                <CarverticalVinLink vin={itemData.value} />
              </React.Fragment>
            ) : (
              <React.Fragment>
                {titleSpan}
                {valueSpan}
              </React.Fragment>
            )}
          </div>
        </Col>
      );
    }

    case DetailGroupType.textArea:
      return (
        <Col key={index} className={`text-justify ${styles.textArea}`}>
          <div className={styles.title}>
            {itemData.title}
            {itemData.tooltip && (
              <Tooltip title={itemData.tooltip} placement="top">
                <Icon
                  className={styles.infoIcon}
                  type="info-circle-o"
                />
              </Tooltip>
            )}
          </div>
          <div>
            {processTextWithPhoneNumbers(replaceLineBreaksByTag(itemData.value), gaEvent, adId)}
          </div>
        </Col>
      );

    default:
      return null;
  }
};

function IndexSection({ sectionName, data, type, category, adId, hrPageName }) {
  const gaEvent: GAEvent = {
    category: "Detalji oglasa",
    action: "Click",
    label: `Klik na telefon - ${hrPageName || ''}`
  };

  return (
    <Row className={styles.sectionWrapper}>
      <Col className={styles.sectionTitle}>{sectionName}</Col>
      <Row
        className={
          type === DetailGroupType.valueWithTitle
            ? styles.sectionContentValueWithTitle
            : styles.sectionContent
        }
      >
        {data.map((itemData: any, index: any) =>
          renderItemData(
            itemData,
            index,
            type,
            resolveLastLineItem(data, index),
            gaEvent,
            adId
          )
        )}
      </Row>
    </Row>
  );
}

export default IndexSection;

IndexSection.defaultProps = {
  type: ""
};



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/IndexSection.tsx